import { Translations } from './translations'

export const pt: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'Magnata do Treinamento de IA',
  settings: 'Configurações',

  // Resources
  resources: 'Recursos',
  money: 'Dinheiro',
  energy: 'Energia',
  compute: 'Computação',
  quality: 'Qualidade',
  totalUsers: 'Total de Usuários',
  price: 'Preço',
  research: 'Pesquisa',

  // Actions
  train: 'Treinar',
  trainCost: 'Custo',
  qualityGain: 'qualidade',
  inference: 'Inferência',
  needUsers: 'Precisa de usuários!',
  usersWaiting: 'usuários aguardando',
  qualityToAttract: 'Qualidade > 40% para atrair',
  researchAction: 'Pesquisar',
  unlocksAfter: 'Desbloqueia após',
  computeSpent: 'computação gasta',
  cost: 'Custo',
  compShort: 'comp',
  energyShort: 'enrg',

  // Hardware
  hardware: 'Hardware',
  computePerSec: 'comp/s',
  usesEnergy: 'usa',
  devicesTotal: 'dispositivos ao total',

  // Models
  training: 'Treinamento',
  yourModels: 'Seus Modelos',
  params: 'parâmetros',
  maxUsers: 'Máx usuários',
  trainCost2: 'Custo de treinamento',
  unlocked: 'desbloqueado',
  researchPoints: 'pesquisa',

  // Upgrades
  upgrades: 'Melhorias',
  upgradesLockedMsg: 'Treine seu modelo a 50% de qualidade para desbloquear melhorias',
  max: 'MÁX',
  all: 'Todos',
  
  // Upgrade tiers
  tierGarage: 'Garagem',
  tierGarageDesc: 'O começo',
  tierStartup: 'Startup',
  tierStartupDesc: 'Era GPT-1',
  tierScaleUp: 'Ampliação',
  tierScaleUpDesc: 'Era GPT-2/3',
  tierEnterprise: 'Empresa',
  tierEnterpriseDesc: 'Era ChatGPT',
  tierHyperscale: 'Hiperscala',
  tierHyperscaleDesc: 'Era GPT-4',
  tierGlobal: 'Global',
  tierGlobalDesc: 'Era Competidores',
  tierSuperintelligence: 'Superinteligência',
  tierSuperintelligenceDesc: 'Era GPT-5+',
  tierSingularity: 'Singularidade',
  tierSingularityDesc: 'Era AGI/ASI',

  // Footer
  computeSpentStat: 'Computação Gasta',
  time: 'Tempo',
  resetGame: 'Reiniciar Jogo',
  resetConfirm: 'Tem certeza de que deseja reiniciar todo o progresso?',
  pause: 'Pausar',
  resume: 'Retomar',

  // Event Log
  eventLog: 'Registro de Eventos',
  welcome: 'Bem-vindo ao GPT Clicker! Treine seu modelo para começar.',

  // Price
  market: 'Mercado',
  pricePerMillion: '$/1M tokens',

  // Tags
  tagEnergy: 'ENRGIA',
  tagCompute: 'COMP',
  tagHw: 'HW',
  tagTrain: 'TREN',
  tagResearch: 'PESQ',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Ano 2020. Você tem uma ideia: treinar um pequeno modelo de linguagem baseado na arquitetura transformer.',
  tutorialFirstTrain: 'Treinamento iniciado! Seu laptop converte energia em computação. Cada treinamento melhora a qualidade do modelo.',
  tutorialQuality20: 'O modelo está aprendendo padrões básicos. Continue treinando para melhorar a qualidade.',
  tutorialQuality40: 'Qualidade acima de 40%! Seu modelo agora pode gerar texto coerente. Os usuários estão começando a notar...',
  tutorialQuality50: 'Melhorias desbloqueadas! Use seus ganhos para comprar hardware melhor e expandir sua capacidade de energia.',
  tutorialFirstUsers: 'Seus primeiros usuários! Clique em INFERÊNCIA para atender suas solicitações e ganhar dinheiro.',
  tutorialUsers10: 'A notícia está se espalhando. Mais usuários estão experimentando seu modelo. Considere aumentar o preço...',
  tutorialMoney100: 'Você tem $100! Hora de atualizar seu hardware. Melhores GPUs = mais computação = treinamento mais rápido.',
  tutorialMoney1k: 'Seu pequeno projeto de IA está se tornando um negócio real. Os investidores estão começando a ligar...',
  tutorialResearchUnlock: 'PESQUISA desbloqueada! Gaste computação em pesquisa para desbloquear modelos maiores e mais poderosos.',
  tutorialFirstResearch: 'Pontos de pesquisa se acumulam. Quando você tiver o suficiente, poderá desbloquear a próxima arquitetura de modelo.',
  tutorialGpt2Small: 'GPT-2 Small desbloqueado! Esta arquitetura pode lidar com tarefas mais complexas. Treine do zero.',
  tutorialGpt2Large: 'GPT-2 Large! As pessoas dizem que isso poderia ser "muito perigoso para lançar"...',
  tutorialGpt3: 'A era do GPT-3 começou. O aprendizado few-shot muda tudo. O mundo está observando.',
  tutorialGpt4: 'GPT-4 chegou. Multimodal, raciocínio e assustadoramente capaz. A corrida da IA se intensifica.',
  tutorialAgi: 'Você conseguiu. AGI está aqui. Ela entende. Ela se melhora. O que acontece a seguir depende de você...',
  tutorialHwGaming: 'Legal! O treinamento é muito mais rápido agora. Seus vizinhos podem reclamar da conta de eletricidade.',
  tutorialHwServer: 'Um rack de servidores real! Você saiu da garagem. Hora de alugar um espaço de escritório.',
  tutorialHwDatacenter: 'Seu próprio datacenter! Agora você está competindo com as grandes empresas de tecnologia.',
  tutorialHwSatellite: 'Computação orbital! A constelação Moonlink fornece poder de processamento sem precedentes do espaço.',
  tutorialHwQuantum: 'Supremacia quântica alcançada. O QC-1024 opera em princípios que deixariam Einstein nervoso.',
  tutorialUsers100: '100 usuários! Você está ganhando tração. Blogs de tecnologia estão escrevendo sobre você.',
  tutorialUsers1k: '1.000 usuários! Você precisa contratar uma equipe de suporte. E talvez alguns advogados.',
  tutorialUsers100k: '100K usuários! Agora você é uma startup unicórnio. VCs estão lutando para lhe dar dinheiro.',
  tutorialUsers1m: 'UM MILHÃO DE USUÁRIOS! Você está reformulando como a humanidade interage com a tecnologia.',

   // Model descriptions
   modelTinyDesc: 'Um humilde começo. Mal coerente, mas funciona.',
   modelGpt2SmallDesc: 'O modelo que começou tudo. Realmente útil.',
   modelGpt2LargeDesc: 'Muito perigoso para lançar... ou é?',
   modelGpt3Desc: 'Aprendizado few-shot. O mundo toma nota.',
   modelGpt4Desc: 'Multimodal. Raciocínio. A corrida armamentista começa.',
   modelAgiDesc: 'Ela entende. Ela se melhora. E agora?',

   // Model descriptions (new keys for all models)
   modelTransformerDesc: 'Um humilde começo. Nasce a arquitetura Transformer.',
   modelGpt1Desc: 'Pré-treinamento generativo. Modelos de linguagem podem aprender!',
   modelGpt2Desc: 'Muito perigoso para lançar... ou é?',
   modelGpt35Desc: 'Magia RLHF. ChatGPT fica viral da noite para o dia.',
   modelGpt41Desc: 'Mais rápido, mais barato, melhor. O jogo da iteração.',
   modelU1Desc: 'Aparece um competidor selvagem. Avanços em raciocínio.',
   model2UDesc: 'A sequência. Chain-of-thought em esteroides.',
   modelGpt5Desc: 'Raciocínio de nível de doutorado. Os cientistas estão nervosos.',
   modelGpt6Desc: 'Escreve código melhor que a maioria dos engenheiros. Todos os modelos anteriores descontinuados.',
   modelGpt7Desc: 'Competência geral artificial alcançada.',
   modelAgi1Desc: 'Ela entende. Ela aprende. Ela se melhora.',
   modelAgi2Desc: 'Auto-melhoria recursiva. A singularidade se aproxima.',
   modelAgi3Desc: 'A iteração final de AGI. Preparando-se para a transcendência.',
   modelAsiDesc: 'Superinteligência Artificial. A Singularidade está aqui.',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Overclockear Laptop',
  upgradeLaptopOverclockDesc: 'Força seu laptop ao máximo: +2 comp/seg',
  upgradeBetterOutlet: 'Melhor Tomada de Corrente',
  upgradeBetterOutletDesc: '+50 energia máxima',
  upgradeSolarPanel: 'Painel Solar',
  upgradeSolarPanelDesc: '+1 energia/seg regeneração',
  upgradePowerGrid: 'Conexão de Rede Elétrica',
  upgradePowerGridDesc: '+5 energia/seg regeneração',
  upgradeNuclearPlant: 'Usina Nuclear',
  upgradeNuclearPlantDesc: '+20 energia/seg regeneração',
  upgradeFusionReactor: 'Reator de Fusão',
  upgradeFusionReactorDesc: '+100 energia/seg regeneração',
  upgradeDysonSphere: 'Esfera de Dyson',
  upgradeDysonSphereDesc: '+1000 energia/seg regeneração',
  upgradeRamUpgrade: 'Atualização de RAM',
  upgradeRamUpgradeDesc: '+50 computação máxima',
  upgradeSsdArray: 'Array de SSDs',
  upgradeSsdArrayDesc: '+200 computação máxima',
  upgradeBetterOptimizer: 'Melhor Otimizador',
  upgradeBetterOptimizerDesc: '+20% eficiência de treinamento',
  upgradeResearchPapers: 'Artigos de Pesquisa',
  upgradeResearchPapersDesc: '+20% eficiência de pesquisa',
  upgradeSelfServicePortal: 'Portal de Autoatendimento',
  upgradeSelfServicePortalDesc: 'Usuários se autoatend em: 0,5 auto-inferências/seg',
  upgradeApiAccess: 'Acesso à API',
  upgradeApiAccessDesc: 'Desenvolvedores integram seu modelo: +1 auto-inferência/seg',
  upgradeMobileApp: 'Aplicativo Móvel',
  upgradeMobileAppDesc: 'Usuários em movimento: +2 auto-inferências/seg',
  upgradeEnterpriseTier: 'Nível Empresarial',
  upgradeEnterpriseTierDesc: 'Grandes clientes, grande volume: +5 auto-inferências/seg',
  upgradeGlobalCdn: 'CDN Global',
  upgradeGlobalCdnDesc: 'Baixa latência mundial: +10 auto-inferências/seg',
  upgradeBasicChatbot: 'Chatbot Básico',
  upgradeBasicChatbotDesc: 'Um widget web simples: +0,2 auto-inferências/seg',
  upgradeBulkApi: 'API em Massa',
  upgradeBulkApiDesc: 'Processamento em lote de alto volume: +3 auto-inferências/seg',
  upgradeNeuralEdge: 'Rede Neural Edge',
  upgradeNeuralEdgeDesc: 'IA na borda: +20 auto-inferências/seg',
  upgradeQuantumInference: 'Inferência Quântica',
  upgradeQuantumInferenceDesc: 'Inferência acelerada por quântica: +50 auto-inferências/seg',
  upgradeOmnipresentAi: 'IA Onipresente',
  upgradeOmnipresentAiDesc: 'IA em todos os lugares, ao mesmo tempo: +100 auto-inferências/seg',
  upgradeTrainingScheduler: 'Agendador de Treinamento',
  upgradeTrainingSchedulerDesc: 'Execuções de treinamento automatizadas: +0,1 auto-treinamentos/seg',
  upgradeTrainingPipeline: 'Pipeline de Treinamento',
  upgradeTrainingPipelineDesc: 'Treinamento contínuo: +0,2 auto-treinamentos/seg',
  upgradeMlOpsPlatform: 'Plataforma MLOps',
  upgradeMlOpsPlatformDesc: 'Automação completa: +0,5 auto-treinamentos/seg',
  upgradeNeuralArchitectureSearch: 'Busca de Arquitetura Neural',
  upgradeNeuralArchitectureSearchDesc: 'IA treina IA: +1 auto-treinamento/seg',
  upgradeSelfImprovingTraining: 'Treinamento Auto-Melhorante',
  upgradeSelfImprovingTrainingDesc: 'Melhoria recursiva: +2 auto-treinamentos/seg',
  upgradeResearchIntern: 'Estagiário de Pesquisa',
  upgradeResearchInternDesc: 'Ajuda de nível iniciante: +0,1 auto-pesquisa/seg',
  upgradeResearchTeam: 'Equipe de Pesquisa',
  upgradeResearchTeamDesc: 'Pesquisadores dedicados: +0,2 auto-pesquisa/seg',
  upgradeResearchDivision: 'Divisão de Pesquisa',
  upgradeResearchDivisionDesc: 'Departamento completo: +0,5 auto-pesquisa/seg',
  upgradeAiResearchLab: 'Laboratório de Pesquisa de IA',
  upgradeAiResearchLabDesc: 'Descoberta assistida por IA: +1 auto-pesquisa/seg',
  upgradeAutonomousResearch: 'Pesquisa Autônoma',
  upgradeAutonomousResearchDesc: 'IA faz a pesquisa: +2 auto-pesquisa/seg',
  upgradeAntimatterReactor: 'Reator de Antimatéria',
  upgradeAntimatterReactorDesc: '+10000 energia/seg regeneração',
  upgradePhDScientists: 'Cientistas com Doutorado',
  upgradePhDScientistsDesc: 'Contratar talentos top: +200% eficiência de pesquisa',
  upgradeResearchLab: 'Laboratório de Pesquisa',
  upgradeResearchLabDesc: 'Instalação dedicada: +500% eficiência de pesquisa',
  upgradeAiResearchAssistant: 'Assistente de Pesquisa de IA',
  upgradeAiResearchAssistantDesc: 'GPT-4 ajuda com pesquisa: +1000% eficiência de pesquisa',
  upgradeAiScientist: 'Cientista de IA',
  upgradeAiScientistDesc: 'IA conduz experimentos autonomamente: +2000% eficiência de pesquisa',
  upgradeResearchSwarm: 'Enxame de Pesquisa de IA',
  upgradeResearchSwarmDesc: 'Milhares de pesquisadores de IA: +5000% eficiência de pesquisa',
  upgradeRecursiveResearch: 'Auto-Melhoria Recursiva',
  upgradeRecursiveResearchDesc: 'IA melhora IA: +10000% eficiência de pesquisa',
  upgradeSingularityResearch: 'Pesquisa de Singularidade',
  upgradeSingularityResearchDesc: 'Além da compreensão: +50000% eficiência de pesquisa',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: 'GPU usada: +3 computação/seg',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: 'GPU gaming: +8 computação/seg',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: 'GPU profissional: +20 computação/seg',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: 'Estação de trabalho: +50 computação/seg',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: 'Rack de servidores (4x A100): +120 computação/seg',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'Cluster de GPUs (8x H100): +300 computação/seg',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: 'Datacenter edge: +800 computação/seg',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: 'Datacenter: +2K computação/seg',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: 'Mega datacenter: +5K computação/seg',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: 'Rede global: +15K computação/seg',
  upgradeHwSupercomputer: 'Frontier X1 Supercomputador',
  upgradeHwSupercomputerDesc: 'Supercomputador: +50K computação/seg',
  upgradeHwSatellite: 'SkyNet Moonlink Constelação',
  upgradeHwSatelliteDesc: 'Satélites orbitais: +200K computação/seg',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: 'Computador quântico: +1M computação/seg',
  upgradeHwDysonCompute: 'Esfera de Computação Dyson',
  upgradeHwDysonComputeDesc: 'Computação em escala estelar: +10M computação/seg',
  upgradeHwMatrioshka: 'Cérebro Matrioshka',
  upgradeHwMatrioshkaDesc: 'Computação em escala galáctica: +100M computação/seg',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: 'GPU usada: +3 comp/seg',
  hwGamingGpuDesc: 'GPU para jogos: +8 comp/seg',
  hwProGpuDesc: 'GPU profissional: +20 comp/seg',
  hwWorkstationDesc: 'Workstation: +50 comp/seg',
  hwServerRackDesc: 'Rack de servidores (4x A100): +120 comp/seg',
  hwGpuClusterDesc: 'Cluster de GPU (8x H100): +300 comp/seg',
  hwMiniDatacenterDesc: 'Datacenter edge: +800 comp/seg',
  hwDatacenterDesc: 'Datacenter: +2K comp/seg',
  hwMegaDatacenterDesc: 'Mega datacenter: +5K comp/seg',
  hwDatacenterNetworkDesc: 'Rede global: +15K comp/seg',
   hwSupercomputerDesc: 'Supercomputador: +50K comp/seg',
   hwSatelliteDesc: 'Satélites orbitais: +200K comp/seg',
   hwQuantumDesc: 'Computador quântico: +1M comp/seg',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: 'Comprado',
  switchedTo: 'Mudado para treinar',
  unlockedModel: 'Desbloqueado',
  scalesToUsers: 'Escala para',
  trainItToAttract: 'usuários. Treine-o para atrair usuários!',
  unlimited: 'ilimitado',
  language: 'Idioma',
  
  // Mobile labels
  mobileResources: 'Recursos',
  mobileModels: 'Modelos',
  mobileHardware: 'Hardware',
  mobileUpgrades: 'Melhorias',
  sell: 'Vender',
  sellFor: 'Vender por',
  discontinueConfirm: 'Descontinuar {model}? Os usuários migrarão para outros modelos.',
  autoInference: 'Auto-inferência',
  autoInferenceRate: 'Auto Infer',
  autoTrain: 'Auto-treinamento',
  autoTrainRate: 'Auto Tren',
  autoResearch: 'Auto-pesquisa',
  autoResearchRate: 'Auto Pesq',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Treine modelos de IA, atenda usuários, construa seu império de IA!',
  tooltipMoney: 'Dinheiro - Ganho das inferências de usuários. Use para comprar melhorias e hardware.',
  tooltipEnergy: 'Energia - Se regenera ao longo do tempo. Alimenta seu hardware para gerar computação.',
  tooltipCompute: 'Computação - Gerada pelo hardware. Usada para treinamento, inferência e pesquisa.',
  tooltipResearch: 'Pontos de Pesquisa - Gaste computação para ganhar PP. Use PP para desbloquear novos modelos de IA.',
  tooltipUsers: 'Usuários - Atraídos pela qualidade do modelo. Mais usuários = mais receita por inferência.',
  tooltipComputeSpent: 'Computação Total Gasta - Computação total usada para treinamento e pesquisa.',
  tooltipPlayTime: 'Tempo de Jogo - Quanto tempo você vem construindo seu império de IA.',
  tooltipSettings: 'Configurações - Opções de debug, reiniciar jogo',

  // Share
  shareButton: 'Compartilhar',
  shareText: 'Estou construindo um império de IA em GPT Clicker! {users} usuários, {money} de receita, treinando {model}. Você consegue bater minha performance de {time}?',
  shareCopied: 'Texto copiado!',
  imageCopied: 'Imagem copiada!',
  shareChallenge: 'Você consegue me vencer?',
  shareTitle: 'Compartilhe seu progresso',
  shareDownload: 'Salvar Imagem',
  model: 'Modelo',

  // Feedback
  feedback: 'Feedback',
  feedbackTitle: 'Enviar Feedback',
  feedbackPlaceholder: 'Diga-nos o que você acha do GPT Clicker...',
  feedbackEmailPlaceholder: 'Email (opcional)',
  feedbackSend: 'Enviar',
  feedbackSending: 'Enviando...',
  feedbackSuccess: 'Obrigado por seu feedback!',
  feedbackError: 'Erro ao enviar feedback. Por favor, tente novamente.',
  feedbackRateLimit: 'Muitas solicitações. Aguarde antes de enviar mais feedback.',
  feedbackClose: 'Fechar',

  // Console messages
  consoleGameLoaded: 'Jogo carregado do arquivo salvo',
  consoleGameSaved: 'Jogo salvo',
  consoleFailedToSave: 'Falha ao salvar jogo:',
  consoleFailedToLoad: 'Falha ao carregar jogo:',
  consoleFailedToClear: 'Falha ao limpar arquivo salvo:',

  // Victory
  victoryTitle: 'Parabéns!',
  victorySubtitle: 'A Civilização Humana alcançou a Singularidade',
  victoryTime: 'Tempo até a Singularidade',
  victoryCta: 'Devemos criar o Singularity Clicker? Deixe um comentário nas redes sociais!',
  victoryClose: 'Continuar Jogando',
}
